import React from 'react';
import { Typography } from 'antd';
import { MAX_ANSWER_MESSAGE_LENGTH } from '@evaltick/shared';
import { SessionInputBar } from '@/components/Interview/SessionInputBar';
import styles from './AnswerInput.module.scss';

const { Text } = Typography;

export const MIN_CHARS = 20;

// Taller than the follow-up composer's default — this is the primary answer
// box, so it should have real room to grow before scrolling internally.
const MAX_ROWS = 12;

interface AnswerInputProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit: () => void;
  disabled: boolean;
}

export const AnswerInput: React.FC<AnswerInputProps> = ({
  value,
  onChange,
  onSubmit,
  disabled,
}) => {
  const remaining = Math.max(0, MIN_CHARS - value.trim().length);
  const showCounter = remaining > 0 && value.length > 0;

  return (
    <div className={styles.container}>
      <Text className={`${styles.counter} ${showCounter ? '' : styles.counterHidden}`}>
        {remaining} more characters needed
      </Text>
      <SessionInputBar
        value={value}
        onChange={onChange}
        onSend={onSubmit}
        placeholder="Type your answer…"
        disabled={disabled}
        sendDisabled={value.trim().length < MIN_CHARS}
        maxRows={MAX_ROWS}
        maxLength={MAX_ANSWER_MESSAGE_LENGTH}
      />
    </div>
  );
};
